import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userGroupUrlCheck } from '../../utils/userGroupUrlCheck';
import { shiftIndividualDetailsAction } from '../../actions/eventActions';
import { SHIFT_INDIVIDUAL_DETAILS_SUCCESS, SHIFT_INDIVIDUAL_DETAILS_ERROR } from '../../actions';
import cheifImage from '../../assets/images/cheif.svg';
import { TM_FIELD_DISTANCE_ID, TM_FIELD_TIME_ID, TM_FIELD_PSNGR_COUNT_ID, TM_FIELD_FLAT_AMOUNT_ID } from "../../configs/staticConfigs";

//import {MSG_NOT_FOUND} from '../../configs/msgConfigs'; 
import { LBL_SKILL, LBL_OTHER_EXPENSES, LBL_QTY, LBL_CHARGE_RATES_CREW, LBL_HOURS_SHORT, LBL_DISCOUNT, LBL_SUB_TOTAL, LBL_TOTAL, LBL_STAFF_PER_VEHICLE, LBL_NO_OF_VEHICLES, LBL_DISTANCE_TO_LOCATION, LBL_DISTANCE, LBL_TRAVEL_COST, LBL_TRAVEL_TIME, LBL_TRAVEL_COST_TOTAL, LBL_MILES, LBL_SHIFT_TOTAL, LBL_TM_FIELD_NAME, LBL_NUM_PASSENGERS, LBL_RATE, LBL_SLNUM, LBL_MINS_SHORT, LBL_RETURN_COST_INCLUDED } from '../../configs/labelConfigs';

import { convertDecimalToHHMM } from '../../utils/commonUtilities';


class QuoteShiftEachDetails extends Component {
    constructor(props) {
        super()
        this.state = {
            quoteShiftId: 0,
            shift_skills: [],
            expenses: [],
            shiftSkillAllDet: {},
            chiefs_required: 0,
            crew_chief_bonus: 0,
            chief_bonus_total: 0,
            shift_length: 0,
            travelCostDetails: {},
        }
    }

    getFieldRate = (affiliateFields, fieldId) => {
        const field = affiliateFields.find(f => f.field_id === fieldId);
        return field ? field.field_rate : '';
    };

    getFieldName = (affiliateFields, fieldId) => {
        const field = affiliateFields.find(f => f.field_id === fieldId);
        return field ? field.field_name : '';
    };

     formatDecimalToHHMM = (decimal) => {
        if (decimal === null || decimal === undefined || decimal === '') return "00:00";

        const [h, m] = decimal.toString().split(".");
        const hours = h.padStart(2, '0');
        const minutes = m ? m.padStart(2, '0') : '00';

        return `${hours}:${minutes}`;
    };


    componentDidMount() {
        if (this.props.quoteShiftId === this.props.activeShiftId) {
            this.props.shiftIndividualDetailsAction(this.props.quoteShiftId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeShiftId && prevProps.activeShiftId && this.props.activeShiftId > 0 && prevProps.activeShiftId !== this.props.activeShiftId) {
            this.props.shiftIndividualDetailsAction(this.props.activeShiftId);
        }
        const { shiftIndividualActivity, shiftIndividualStatus, shiftIndividualDetails } = this.props;


        if (shiftIndividualActivity && (shiftIndividualActivity !== prevProps.shiftIndividualActivity || shiftIndividualStatus !== prevProps.shiftIndividualStatus)) {
            var arrResp = shiftIndividualActivity.split('~~');
            var actString = arrResp[0];
            let shift_skills = [];
            let expenses = [];
            let shiftSkillAllDet = {};
            var chiefs_required = 0;
            var crew_chief_bonus = 0;
            var chief_bonus_total = 0;
            var shift_length = 0;

            if (actString === SHIFT_INDIVIDUAL_DETAILS_SUCCESS && shiftIndividualStatus === 200) {
                shiftSkillAllDet = shiftIndividualDetails;
                if (shiftIndividualDetails.hasOwnProperty('crew_chief_bonus') && Number(shiftIndividualDetails.crew_chief_bonus)) crew_chief_bonus = parseFloat(shiftIndividualDetails.crew_chief_bonus);
                if (shiftIndividualDetails.hasOwnProperty('chiefs_required') && Number(shiftIndividualDetails.chiefs_required)) chiefs_required = parseFloat(shiftIndividualDetails.chiefs_required);
                if (shiftIndividualDetails.hasOwnProperty('chief_bonus_total') && Number(shiftIndividualDetails.chief_bonus_total)) chief_bonus_total = parseFloat(shiftIndividualDetails.chief_bonus_total);
                if (shiftIndividualDetails.hasOwnProperty('shift_length') && Number(shiftIndividualDetails.shift_length)) shift_length = parseFloat(shiftIndividualDetails.shift_length);


                if (Array.isArray(shiftIndividualDetails.shift_skills)) shift_skills = shiftIndividualDetails.shift_skills;
                if (Array.isArray(shiftIndividualDetails.expenses)) expenses = shiftIndividualDetails.expenses;
                this.setState({ shift_skills: shift_skills, expenses: expenses, shiftSkillAllDet: shiftSkillAllDet, travelCostDetails: shiftIndividualDetails.travel_cost_details || {}, chiefs_required, crew_chief_bonus, chief_bonus_total, shift_length });
            }
            else if (actString === SHIFT_INDIVIDUAL_DETAILS_ERROR) {
                this.setState({ shift_skills: shift_skills, expenses: expenses, shiftSkillAllDet: shiftSkillAllDet, travelCostDetails: {}, });
            }
        }
    }


    render() {
        const { profileCurrency } = this.props;
        const { shift_skills, expenses, shiftSkillAllDet, travelCostDetails } = this.state;
        let shiftLength = 0;
        if (shift_skills && this.state.chiefs_required) shiftLength = convertDecimalToHHMM(this.state.shift_length);
        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrewChief = '';

        if (userGroupData !== undefined) {
            lblCrewChief = userGroupData.supervisor_name;
        }

        // TRAVEL COST - SINGLE FIELD ONLY SETTINGS 
        let tcSnglFldShowTravelTime = true, tcSnglFldShowTravelDistance = true;
        let tcSnglFldShowCalcField = true, tcSnglFldFieldSuffix = '', tcSnglFldCalcFieldName = '', tcSnglFldCalcFieldUnit = '', tcSnglFldCalcFieldValue = '';
        if (Object.keys(travelCostDetails).length > 0 && travelCostDetails?.travel_fields.length === 1) {
            if (Number(travelCostDetails.travel_fields[0].field_type) === TM_FIELD_DISTANCE_ID) {
                tcSnglFldShowTravelDistance = false;
                tcSnglFldCalcFieldName = LBL_DISTANCE_TO_LOCATION;
                tcSnglFldCalcFieldUnit = ' (' + LBL_MILES + ')';
                tcSnglFldCalcFieldValue = travelCostDetails?.travel_distance_miles;
            } else if (Number(travelCostDetails.travel_fields[0].field_type) === TM_FIELD_TIME_ID) {
                tcSnglFldShowTravelTime = false;
                tcSnglFldCalcFieldName = LBL_TRAVEL_TIME;
                tcSnglFldCalcFieldUnit = ' (' + LBL_HOURS_SHORT + ')';
                tcSnglFldCalcFieldValue = travelCostDetails?.travel_duration_hh_mm;
            }
            else if (Number(travelCostDetails.travel_fields[0].field_type) === TM_FIELD_PSNGR_COUNT_ID) {
                tcSnglFldCalcFieldName = LBL_STAFF_PER_VEHICLE;
                tcSnglFldCalcFieldUnit = '';
                tcSnglFldCalcFieldValue = 'staffCount';
            } else if (Number(travelCostDetails.travel_fields[0].field_type) === TM_FIELD_FLAT_AMOUNT_ID) {
                tcSnglFldShowCalcField = false;
                tcSnglFldCalcFieldName = '';
                tcSnglFldCalcFieldUnit = '';
                tcSnglFldFieldSuffix = ' (' + profileCurrency + ')';
            }
        }

        // TRAVEL COST - MULTIPLE FIELDS SETTINGS 
        let tcMultiColSpanValue = 0;
        let tcMultiFldShowTravelTime = false, tcMultiFldShowTravelDistance = false, tcMultiFldShowNumPassenger = false;
        if (Object.keys(travelCostDetails).length > 0 && travelCostDetails?.travel_fields.length > 1) {
            travelCostDetails.travel_fields.map(tfItem => {
                if (Number(tfItem.field_type) === TM_FIELD_DISTANCE_ID) {
                    tcMultiFldShowTravelDistance = true;
                    tcMultiColSpanValue++;
                } else if (Number(tfItem.field_type) === TM_FIELD_TIME_ID) {
                    tcMultiFldShowTravelTime = true;
                    tcMultiColSpanValue++;
                }
                else if (Number(tfItem.field_type) === TM_FIELD_PSNGR_COUNT_ID) {
                    tcMultiFldShowNumPassenger = true;
                    tcMultiColSpanValue++;
                }
                // else if(Number(tfItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {

                // }
            })
        }

        return (
            <React.Fragment>

                <div className="row ml-l-r">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col" className="width-40-percent text-left">{LBL_QTY + ' x ' + LBL_SKILL}</th>
                                {/* <th scope="col">Pay rates ({profileCurrency})</th> */}
                                <th scope="col" className="width-20-percent text-right">{LBL_CHARGE_RATES_CREW} ({profileCurrency})</th>
                                <th scope="col" className="width-20-percent text-right">{LBL_HOURS_SHORT}</th>
                                {/* <th scope="col">Qty</th> */}
                                <th scope="col" className="width-20-percent text-right">{LBL_TOTAL} ({profileCurrency})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {(shift_skills && shift_skills.length===0) && 
                            <tr><td className="center-align" colSpan="6">{MSG_NOT_FOUND}</td></tr>
                            } */}
                            {shift_skills && shift_skills.map((skillItem) => {
                                let skillHours = convertDecimalToHHMM(skillItem.hour);
                                return (
                                    <tr key={skillItem.id}>
                                        <td className="width-40-percent text-left">{skillItem.count} x <i className={`fas ${skillItem.skill.skill_icon}`}></i> {skillItem.skill.skill_name}</td>
                                        {/* <td>{skillItem.base_pay_rate}</td> */}
                                        <td className="width-20-percent text-right">{skillItem.charge_rate}</td>
                                        <td className="width-20-percent text-right">
                                            {skillHours + ' ' + LBL_HOURS_SHORT.toLowerCase()}
                                        </td>
                                        {/* <td>{skillItem.count}</td> */}
                                        <td className="width-20-percent text-right">{skillItem.charge_rate_total}</td>
                                    </tr>)
                            })}

                            {shift_skills && this.state.chiefs_required > 0 && <tr >
                                <td className="width-40-percent text-left">
                                    {this.state.chiefs_required} x &nbsp;
                                    <img className="cheifimg-icon" src={cheifImage} alt="chief icon" />
                                    {lblCrewChief}
                                </td>
                                <td className="width-20-percent text-right">
                                    {/* {this.state.crew_chief_bonus.toFixed(2)} */}
                                    {(parseFloat(this.state.chief_bonus_total) / parseFloat(this.state.chiefs_required)).toFixed(2)}
                                </td>
                                <td className="width-20-percent text-right">
                                    {shiftLength + ' ' + LBL_HOURS_SHORT.toLowerCase()}
                                </td>
                                <td className="width-20-percent text-right">{this.state.chief_bonus_total.toFixed(2)}</td>
                            </tr>
                            }

                            {(expenses && expenses.length >= 1) && <tr className="head">
                                <th colSpan="3" className="text-bold text-left">{LBL_OTHER_EXPENSES}</th>
                                <th scope="col" className="width-20-percent text-bold text-right">
                                    {/* {LBL_TOTAL} ({profileCurrency}) */}
                                </th>
                            </tr>}
                            {expenses && expenses.length >= 1 && expenses.map((expItem) => {
                                return (
                                    <tr key={expItem.id}>
                                        <td colSpan="3" className="text-left">{expItem.other_expense.name}</td>
                                        <td className="width-20-percent text-right">{expItem.cost}</td>
                                    </tr>)
                            })}


                            {shift_skills && (shift_skills.length >= 1) && shiftSkillAllDet?.discount && parseFloat(shiftSkillAllDet.discount) > 0 ?
                                <>
                                    <tr className="head">
                                        <td colSpan="3" className="text-left text-bold"><b>{LBL_SUB_TOTAL}</b></td>
                                        <td className="width-20-percent text-right text-bold"><b>{(parseFloat(shiftSkillAllDet.sub_total)).toFixed(2)}</b></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3" className="text-left text-bold"><b>{LBL_DISCOUNT + (shiftSkillAllDet?.discount_percentage ? (' (' + shiftSkillAllDet.discount_percentage + '%)') : '')}</b></td>
                                        <td className="width-20-percent text-right text-bold"><b>{(parseFloat(shiftSkillAllDet.discount)).toFixed(2)}</b></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3" className="text-left text-bold"><b>{LBL_TOTAL}</b></td>
                                        <td className="width-20-percent text-right text-bold"><b>{(parseFloat(shiftSkillAllDet.sub_total) - parseFloat(shiftSkillAllDet.discount)).toFixed(2)}</b></td>
                                    </tr>
                                </>
                                :
                                <></>
                            }

                            {shift_skills && (shift_skills.length >= 1) && shiftSkillAllDet?.discount && parseFloat(shiftSkillAllDet.discount) == 0 ?
                                <>
                                    <tr className="head">
                                        <td colSpan="3" className="text-left text-bold"><b>{LBL_TOTAL}</b></td>
                                        <td className="width-20-percent text-right text-bold"><b>{(parseFloat(shiftSkillAllDet.sub_total)).toFixed(2)}</b></td>
                                    </tr>
                                </>
                                :
                                <>
                                </>
                            }




                            {/* 
                            <tr>
                                <td colSpan="3" className="text-left text-bold"><b>{LBL_DISCOUNT+(shiftSkillAllDet?.discount_percentage ? (' ('+shiftSkillAllDet.discount_percentage+'%)') : '')}</b></td>
                                <td className="width-20-percent text-right text-bold"><b>{(parseFloat(shiftSkillAllDet.discount)).toFixed(2)}</b></td>
                            </tr> 
                            
                            {expenses && (expenses.length >= 1) &&
                                <tr>
                                    <td colSpan="3" className="text-bold text-left"><b>{LBL_TOTAL}</b></td>
                                    <td className="width-20-percent text-bold text-right"><b>{shiftSkillAllDet.other_expense_total}</b></td>
                                </tr>
                            } */}
                        </tbody>
                    </table>

                    {Object.keys(travelCostDetails).length === 0 ? null : (<>

                        {travelCostDetails?.travel_fields.length === 1 ? <>

                            <table className="table mt-3">
                                <thead>
                                    <tr>
                                        <th colSpan={5}>
                                            <div className='d-flex justify-content-between align-items-center w-100 font-14'>
                                                <div className='text-bold'>{LBL_TRAVEL_COST} {travelCostDetails.travel_return_cost_included ? LBL_RETURN_COST_INCLUDED : ''} </div>
                                                {tcSnglFldShowTravelDistance ? <div className='text-normal'>{LBL_DISTANCE_TO_LOCATION}: {parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)} {LBL_MILES}</div> : null}
                                                {tcSnglFldShowTravelTime ? <div className='text-normal'>{LBL_TRAVEL_TIME}: {this.formatDecimalToHHMM(travelCostDetails.travel_duration_hh_mm)} {" (" +LBL_HOURS_SHORT +":" +LBL_MINS_SHORT +")"} </div> : null}
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th className=" text-right">{travelCostDetails.travel_fields[0].field_name + tcSnglFldFieldSuffix}</th>
                                        <th scope="col" className=" text-right">{tcSnglFldShowCalcField ? <>{tcSnglFldCalcFieldName} <span className='text-normal'>{tcSnglFldCalcFieldUnit}</span></> : null}</th>
                                        <th scope="col" className=" text-right">{LBL_NO_OF_VEHICLES}</th>
                                        <th scope="col" className=" text-right">{LBL_TOTAL} ({profileCurrency})</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {travelCostDetails.calculation_details.map((tcItem, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className=" text-right">{parseFloat(tcItem.affiliate_fields[0].field_rate).toFixed(2)}</td>
                                            <td className=" text-right">{tcSnglFldShowCalcField ? <>{tcSnglFldCalcFieldValue === 'staffCount' ? tcItem.staff_per_vehicle : tcSnglFldCalcFieldValue}</> : null}</td>
                                            <td className=" text-right">{tcItem.no_of_vehicles}</td>
                                            <td className=" text-right">{parseFloat(tcItem.cost).toFixed(2)}</td>
                                        </tr>))
                                    }
                                    <tr className="head">
                                        <td colSpan={travelCostDetails.travel_fields.length + 3} className="text-left text-bold">
                                            {LBL_TRAVEL_COST_TOTAL}:
                                        </td>
                                        <td className="text-right width-20-percent text-bold">
                                            {parseFloat(travelCostDetails.total_travel_cost).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                            :
                            <>
                                <table className="table mt-3" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>
                                                <div className='d-flex justify-content-between align-items-center w-100 font-14'>
                                                    <div className='text-bold'>{LBL_TRAVEL_COST}  {travelCostDetails.travel_return_cost_included ? LBL_RETURN_COST_INCLUDED : ''}</div>
                                                    {!tcMultiFldShowTravelDistance ? <div className='text-normal'>{LBL_DISTANCE_TO_LOCATION}: {parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)} {LBL_MILES}</div> : null}
                                                    {!tcMultiFldShowTravelTime ? <div className='text-normal'>{LBL_TRAVEL_TIME}: {this.formatDecimalToHHMM(travelCostDetails.travel_duration_hh_mm)} {" (" +LBL_HOURS_SHORT +":" +LBL_MINS_SHORT +")"} </div> : null}
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan={2} className='bgWhite' >
                                                {travelCostDetails.calculation_details.map((tcItem, index) => (
                                                    <>
                                                        <table className="table" style={{ width: '100%' }}>
                                                            <thead>
                                                                <tr key={'row' + index.toString()}>
                                                                    <th>{LBL_TM_FIELD_NAME}</th>
                                                                    <th className="text-right">{LBL_RATE}</th>
                                                                    {tcMultiFldShowTravelDistance ? <th className=" text-right">{LBL_DISTANCE} <span className='text-normal'>{' (' + LBL_MILES + ')'}</span> </th> : null}
                                                                    {tcMultiFldShowTravelTime ? <th className=" text-right">{LBL_TRAVEL_TIME} <span className='text-normal'>{' (' + LBL_HOURS_SHORT + ')'}</span> </th> : null}
                                                                    {tcMultiFldShowNumPassenger ? <th className=" text-right">{LBL_NUM_PASSENGERS} </th> : null}
                                                                    <th className=" text-right">{LBL_NO_OF_VEHICLES}</th>
                                                                    <th className=" text-right">{LBL_TOTAL} ({profileCurrency})</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tcItem.affiliate_fields.map(fieldItem => (
                                                                    <tr key={fieldItem.field_id}>
                                                                        <td>{this.getFieldName(travelCostDetails.travel_fields, fieldItem.field_id)}</td>
                                                                        <td className=" text-right">{parseFloat(fieldItem.field_rate).toFixed(2)}</td>
                                                                        {Number(fieldItem.field_type) === TM_FIELD_DISTANCE_ID ? <>
                                                                            <td className=" text-right">{parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)}</td>
                                                                            {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null}
                                                                            {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null}
                                                                        </> :
                                                                            Number(fieldItem.field_type) === TM_FIELD_TIME_ID ? <>
                                                                                {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null}
                                                                                <td className=" text-right">{parseFloat(travelCostDetails?.travel_duration_hh_mm).toFixed(2)}</td>
                                                                                {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null}
                                                                            </> :
                                                                                Number(fieldItem.field_type) === TM_FIELD_PSNGR_COUNT_ID ? <>
                                                                                    {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null}
                                                                                    {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null}
                                                                                    <td className=" text-right">{tcItem.staff_per_vehicle}</td>
                                                                                </> :
                                                                                    Number(fieldItem.field_type) === TM_FIELD_FLAT_AMOUNT_ID ? <>
                                                                                        {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null}
                                                                                        {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null}
                                                                                        {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null}
                                                                                    </> :
                                                                                        <></>
                                                                        }
                                                                        <td className=" text-right">{tcItem.no_of_vehicles}</td>
                                                                        <td className=" text-right">{parseFloat(fieldItem.field_total).toFixed(2)}</td>
                                                                    </tr>
                                                                ))}
                                                                <tr className="head">
                                                                    <td colSpan={(tcMultiColSpanValue + 3)} className="text-bold text-left">
                                                                        {LBL_SUB_TOTAL}
                                                                    </td>
                                                                    <td className="text-bold text-right">
                                                                        {parseFloat(tcItem.cost).toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </>))
                                                }
                                            </td>
                                        </tr>
                                        <tr className="head">
                                            <td className="text-bold text-left">
                                                {LBL_TRAVEL_COST_TOTAL}:
                                            </td>
                                            <td className="text-bold text-right width-20-percent">
                                                {parseFloat(travelCostDetails.total_travel_cost).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                        }
                    </>)}






                    {/* <>
                            <div className=' mt-4 d-flex justify-content-between align-items-center w-100 font-14'>
                                <div className=''>{LBL_TRAVEL_COST} </div>
                                <div className=''>{LBL_DISTANCE_TO_LOCATION}: {travelCostDetails?.travel_distance_miles} Miles</div>
                                <div className=''>{LBL_TRAVEL_TIME}: {travelCostDetails?.travel_duration_hh_mm} Hrs</div>
                            </div>
                            <table className="table mt-2">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {travelCostDetails.travel_fields.map(field => (
                                            <th key={field.field_id} className=" text-right text-wrap">{field.field_name}</th>
                                        ))}
                                        <th scope="col" className=" text-right text-wrap">{LBL_STAFF_PER_VEHICLE}</th>
                                        <th scope="col" className=" text-right text-wrap">{LBL_NO_OF_VEHICLES}</th>
                                        <th scope="col" className=" text-right text-wrap">{LBL_TOTAL} ({profileCurrency})</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {travelCostDetails.calculation_details.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {travelCostDetails.travel_fields.map(field => (
                                                <td key={field.field_id} className=" text-right">{this.getFieldRate(item.affiliate_fields, field.field_id)}</td>
                                            ))}

                                            <td className=" text-right">{item.staff_per_vehicle}</td>
                                            <td className=" text-right">{item.no_of_vehicles}</td>
                                            <td className=" text-right">{item.cost.toFixed(2)}</td>
                                        </tr>))
                                    }
                                    <tr className="head">
                                        <td colSpan={travelCostDetails.travel_fields.length + 3} className="text-left text-bold">
                                            {LBL_TRAVEL_COST_TOTAL}:
                                        </td>
                                        <td className="text-right width-20-percent text-bold">
                                            {travelCostDetails?.total_travel_cost.toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </> */}



                    <div className=' mt-4 px-2 d-flex justify-content-between align-items-center w-100 table-footer  font-14'>
                        <div className=''>{LBL_SHIFT_TOTAL}:</div>
                        <div className=''>{profileCurrency + " "}{(parseFloat(shiftSkillAllDet.shift_total)).toFixed(2)}</div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        shiftIndividualDetails: state.event.shiftIndividualDetails,
        shiftIndividualStatus: state.event.shiftIndividualStatus,
        shiftIndividualActivity: state.event.shiftIndividualActivity,
        shiftIndividualErrorData: state.event.shiftIndividualErrorData,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        shiftIndividualDetailsAction: shiftIndividualDetailsAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(QuoteShiftEachDetails);
